export const SET_RENTABLES = 'SET_RENTABLES';
export const SET_RENTABLE = 'SET_RENTABLE';
export const ADD_RENTABLE = 'ADD_RENTABLE';
export const UPDATE_RENTABLE = 'UPDATE_RENTABLE';
export const REMOVE_RENTABLE = 'REMOVE_RENTABLE';
export const CLEAR_RENTABLE = 'CLEAR_RENTABLE';
export const CLEAR_RENTABLES = 'CLEAR_RENTABLES';
